import { render, staticRenderFns } from "./ContractSummary.vue?vue&type=template&id=42480621&scoped=true"
import script from "./ContractSummary.vue?vue&type=script&lang=js"
export * from "./ContractSummary.vue?vue&type=script&lang=js"
import style0 from "./ContractSummary.vue?vue&type=style&index=0&id=42480621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42480621",
  null
  
)

export default component.exports